import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-menu-lateral',
  standalone: true,
  imports: [],
  templateUrl: './menu-lateral.component.html',
  styleUrl: './menu-lateral.component.css'
})
export class MenuLateralComponent implements OnInit {
  @Input() items: string[] = [];
  @Input() defaultValue?: string;
  @Input() itemSelected: string | undefined;;
  @Output() itemSelectedChange = new EventEmitter<string>();

  ngOnInit(): void {
    this.itemSelected = this.defaultValue;
  }

  selectItem(item: string): void {
    this.itemSelected = item;
    this.itemSelectedChange.emit(item);
  }

  onKeyPress(item: string): void {
    this.selectItem(item);
  }
}

